@if (isSmallScreen$()){
  <button mat-mini-fab class="costum-mat-primary-container" (click)="handleClick()">
    <mat-icon>lightbulb</mat-icon>
  </button>
}
@else {
  <button mat-flat-button class="costum-mat-primary-container" (click)="handleClick()">
    <mat-icon>lightbulb</mat-icon>
    Mehr
  </button>  
}